<template>
  <fin-work-in-progess-page title="ETF-Analyzer"/>
</template>

<script>
import FinWorkInProgessPage from "@/components/common/WorkInProgressPage"

export default {
  name: "FinEtfAnalyzer",
  components: {FinWorkInProgessPage}
}
</script>

<style scoped>

</style>
